import { BrowserRouter } from 'react-router-dom';
import { ThemeProvider } from '@mui/material';
import * as Sentry from '@sentry/react';
import { QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';

import { ErrorFallbackPage } from '@/pages/errorFallback';
import { queryClient } from '@/shared/api/query-client';
import { PickersLocaleProvider, theme } from '@/shared/ui';
import { ConfirmationsProvider } from '@/shared/ui/Confirmations';
import { LoaderProvider } from '@/shared/ui/Loader';
import { NotificationsProvider } from '@/shared/ui/Notifications';

const renderFallback = (props: { resetError: () => void }) => (
  <ErrorFallbackPage {...props} />
);

export const AppProviders = ({ children }: { children: React.ReactNode }) => {
  return (
    <ThemeProvider theme={theme}>
      <Sentry.ErrorBoundary fallback={renderFallback}>
        <BrowserRouter>
          <QueryClientProvider client={queryClient}>
            <NotificationsProvider>
              <PickersLocaleProvider>
                <LoaderProvider>
                  <ReactQueryDevtools />
                  <ConfirmationsProvider>{children}</ConfirmationsProvider>
                </LoaderProvider>
              </PickersLocaleProvider>
            </NotificationsProvider>
          </QueryClientProvider>
        </BrowserRouter>
      </Sentry.ErrorBoundary>
    </ThemeProvider>
  );
};
